// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iRE_B","clinicsSelect":"styles_clinicsSelect__1oGfI"};